import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Normalize user role (handle both 'company_admin' and 'companyadmin')
  const userRole = user.role;
  const normalizedUserRole = userRole === 'company_admin' ? 'companyadmin' : userRole;

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(normalizedUserRole)) {
    // Redirect to dashboard if user doesn't have permission
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleProtectedRoute;